export const AnnouncementSearchEndpoint = {
  get: (id: any) => `announcement-detail/${id}`
}
